import React  from 'react';
import './card.scss';

interface ICardProps {
  children: any;
}

export const Card: React.FC<ICardProps> = ({ children }) => {
  const customCardStyles = {
    '--page-background-color': window?.tz_globalConfigs?.styling?.pageBackgroundColor || '#fff',
    '--widget-background-color': window?.tz_globalConfigs?.styling?.widgetBackgroundColor || '#fff',
  }  as React.CSSProperties;

  return (
    <div className="card-main" style={customCardStyles}>
      {children}
    </div>
  );
};
